import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["action", "disabled", "isLocked", "isLoading", "numberOfOperations"];
import { useCreditCheck } from 'policy-lib';
import { EnrichmentActionButton } from './EnrichmentActionButton';
import { useEnrichmentCredits } from '../EnrichmentCreditsProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export function UsageCheckButton(_ref) {
  let {
      action,
      disabled,
      isLocked: isLockedProvided,
      isLoading: isLoadingProvided = false,
      numberOfOperations
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    hasError,
    isLoading: isLoadingCredits
  } = useEnrichmentCredits();
  const {
    isAuthorized
  } = useCreditCheck({
    action,
    numberOfOperations
  });
  const isLocked = (!isAuthorized || isLockedProvided) && !hasError;
  const isLoading = isLoadingCredits || isLoadingProvided;
  const isDisabled = disabled || hasError || isLoading;
  return /*#__PURE__*/_jsx(EnrichmentActionButton, Object.assign({}, rest, {
    disabled: isDisabled,
    isLocked: isLocked
  }));
}